<template>
  <Card
    class="blog-item"
    component="router-link"
    :to="{ name: 'blog-slug', params: { slug: document.slug } }"
    elevate-on-hover
    itemscope
    itemtype="http://schema.org/BlogPosting"
  >
    <time itemprop="datePublished" :datetime="document.createdAt" />
    <time itemprop="dateModified" :datetime="document.updatedAt" />

    <RatioBox
      class="blog-item__img"
      :ratio="615 / 300"
      itemscope
      itemtype="http://schema.org/ImageObject"
    >
      <template>
        <nuxt-img
          loading="lazy"
          preset="blogThumb"
          :src="document.img"
          :alt="document.imgAlt"
          width="615"
          height="300"
          itemtype="http://schema.org/ImageObject"
        />

        <meta itemprop="url" :content="document.img" />
        <meta itemprop="width" :content="document.imgWidth" />
        <meta itemprop="height" :content="document.imgHeight" />
      </template>
    </RatioBox>
    <Divider size="1px" color="gray200" />
    <CardTitle class="blog-item__title">
      <VText component="h2" variant="h3" itemprop="headline">{{
        document.title
      }}</VText>
    </CardTitle>
    <CardText>
      <VText class="blog-item__text" itemprop="description">{{
        document.description
      }}</VText>
    </CardText>
  </Card>
</template>

<script>
import {
  Card,
  CardTitle,
  CardText,
  VText,
  Divider,
  RatioBox,
} from '@campsite-bio/component-lib';

export default {
  components: {
    Card,
    CardTitle,
    CardText,
    VText,
    Divider,
    RatioBox,
  },

  props: {
    document: Object,
  },
};
</script>

<style lang="scss" scoped>
.blog-item {
  display: block;
  text-decoration: none !important;

  &__img {
    border-top-left-radius: var(--g-border-radius-standard);
    border-top-left-radius: Min(
      var(--g-border-radius-standard),
      var(--g-border-radius-min)
    );
    border-top-right-radius: var(--g-border-radius-standard);
    border-top-right-radius: Min(
      var(--g-border-radius-standard),
      var(--g-border-radius-min)
    );
    background: var(--g-color-gray-200);

    &::v-deep img {
      border-top-left-radius: var(--g-border-radius-standard);
      border-top-left-radius: Min(
        var(--g-border-radius-standard),
        var(--g-border-radius-min)
      );
      border-top-right-radius: var(--g-border-radius-standard);
      border-top-right-radius: Min(
        var(--g-border-radius-standard),
        var(--g-border-radius-min)
      );
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__title {
    a {
      color: inherit;
      text-decoration: none !important;
    }
  }
}
</style>
